<template>
  <div class='SearchResult'>
    <div class="cont-load" v-if="SearchLoad">
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '15px' : '40px'"
      style="z-index: 999"
      />
    </div>
    <div class="cont-itens" v-if="!SearchLoad">
      <enb-produto
      v-for="(i, key) in ResultSearch01"
      :key="key"
      :data="i"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { loaders } from '@/components/Spinner'
import EnbProduto from '../Produtos/Produto/EnbProduto'
export default {
  name: 'SearchResult',
  components: { ...loaders, EnbProduto },
  computed: {
    ...mapGetters(['ResultSearch01', 'SearchLoad', 'Prefes'])
  }
}
</script>

<style scoped>
.SearchResult {
  width: 100%;
  min-height: 510px;
  padding-top: 5%;
}

.cont-itens {
  width: 78%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  padding: 1%;
}

.cont-load {
  min-height: 510px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
